module.exports = __webpack_public_path__ + "images/icon-machina-outlined.svg?2c39cbac826405843afb39104f72b236";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/icon-machina-outlined.svg
// module id = hVGe
// module chunks = 23